<template>
  <div class="col-12 page_content_area">
    <div class="container">
      <div class="row">
        <div class="career_counselling_content_area page_article_block col-12">
          <div class="article_content">
            <div class="career_counselling_content_block clearfix">
              <div class="photo_area">
                <div
                  class="photo_img"
                  :style="`background-image: url('${ this.currentCounselorGetter.counselor_avatar && this.currentCounselorGetter.counselor_avatar.length ? this.currentCounselorGetter.counselor_avatar[0].attachment_url : '/images/profile_photo.png'}')`"
                />
              </div>
              <div class="content_area">
                <div class="title_area clearfix">
                  <div class="name float-left">
                    {{ currentCounselorGetter.counselor_name }}
                  </div>
                </div>
                <div class="content_detail_area clearfix">
                  <div class="content_detail_block">
                    <div class="block_content clearfix">
                      <div class="heading_title">
                        現職
                      </div>
                      <div class="content_info">
                        {{ currentCounselorGetter.counselor_work_at }} {{ currentCounselorGetter.counselor_title }}
                      </div>
                    </div>
                    <div class="block_content clearfix">
                      <div class="heading_title">
                        專長
                      </div>
                      <div
                        class="content_info"
                        v-html="currentCounselorGetter.counselor_summary_of_qualification"
                      />
                    </div>
                    <div class="block_content clearfix">
                      <div class="heading_title">
                        注意事項
                      </div>
                      <div class="content_info">
                        {{ counselling_notice }}
                      </div>
                    </div>
                  </div>
                  <div class="content_detail_block mb-2">
                    <div class="heading_title">
                      重要經歷
                    </div>
                    <div
                      class="content_info"
                      v-html="currentCounselorGetter.counselor_work_experience"
                    />
                  </div>
                </div>
                <career-counselling-card-form
                  :counselor="currentCounselorGetter"
                  :title-ch="titleCh"
                  :title-en="titleEn"
                  @time-slot-change="timeSlotChange"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import CareerCounsellingCardForm from './CareerCounsellingCardForm'
export default {
  name: 'CareerCounsellingDetailsContent',
  inject: ['counselorType'],
  components: {
    CareerCounsellingCardForm
  },
  props: {
    titleCh: {
      type: String,
      default: ''
    },
    titleEn: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      'counselling_notice': ''
    }
  },
  computed: {
    ...mapGetters('pages/career-counselling', [
      'servicesGetter',
      'currentCounselorGetter'
    ])
  },
  async created () {
    if (this.counselorType === 'career-counselors') {
      try {
		await this.getCareerCounselorDetailById(this.$route.params.id)
	  } catch (err) {
		this.$router.push('/career-counselling/career-counselors');
	  }
      if (!this.servicesGetter.length) {
        await this.getAllCareerCounselorServices()
      }
    } else {
      try {
		await this.getIndustryMentorDetailById(this.$route.params.id);
	  } catch (err) {
		this.$router.push('/career-counselling/industry-mentors');
	  }
      if (!this.servicesGetter.length) {
        await this.getAllIndustryMentorServices()
      }
    }
  },
  methods: {
    ...mapActions('pages/career-counselling', [
      'getCareerCounselorDetailById',
      'getIndustryMentorDetailById',
      'getAllCareerCounselorServices',
      'getAllIndustryMentorServices'
    ]),
    timeSlotChange (msg) {
      let note
      this.currentCounselorGetter.counselling_notice.forEach(function (value) {
        if (value.id === msg.value) {
          note = value.note
        }
      })
      this.counselling_notice = note
    }
  }
}
</script>
